import { httpRequest } from "@services/http";
import type { ChartResponse, DashboardParams } from "../models/dashboard";
import { legacyDashboardUrl } from "./legacyDashboardUrl";

export class CommandGetLaunchChart {
    async run(chartId: string, params: DashboardParams, sort = ""): Promise<ChartResponse> {
        const url = legacyDashboardUrl(`reporting/get-chart-data/launch:${chartId}/`);
        url.searchParams.set("launch_id", params.launch_id);
        url.searchParams.set("start_date", params.start_date);
        url.searchParams.set("end_date", params.end_date);
        url.searchParams.set("sort", sort);
        return await httpRequest<ChartResponse>(url.toString());
    }
}
